module.exports = __webpack_public_path__ + "media/images/sites/health/f-painel-c14cdf84b5e7ce0197857f5efb237f3b.jpg";